// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from "@leagueplatform/genesis-core";

export const emblemHealthTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: "#FFFFFFFF",
        secondary: "#F1F2F2FF",
        tertiary: "#F2EDFAFF",
      },
      card: {
        primary: "#F2F2F2FF",
        secondary: "#FFFFFFFF",
        disabled: "#D7D7D7FF",
      },
      screenHeader: { background: "#F2EDFAFF" },
      skeleton: {
        shimmer: {
          background: "#E7E7E7FF",
          overlay:
            "linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)",
        },
      },
    },
    onSurface: {
      text: {
        primary: "#1A1A1AFF",
        subdued: "#545454FF",
        reversed: "#FFFFFFFF",
        critical: "#DD0E0EFF",
        success: "#507C03FF",
        warning: "#C94F08FF",
      },
      border: { subdued: "#EFEFEFFF", default: "#C2C2C2FF", card: "#EBEBEBFF" },
      icon: { primary: "#636363FF" },
    },
    interactive: {
      action: {
        primary: "#5B3880FF",
        hovered: "#361A51FF",
        pressed: "#513271FF",
        subdued: "#66686BFF",
        disabled: "#D6D6D6FF",
      },
      icon: { default: "#FFFFFFFF", disabled: "#949494FF" },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF",
      },
      border: {
        default: "#949494FF",
        hovered: "#4E4E4EFF",
        disabled: "#D6D6D6FF",
        critical: { default: "#DD0E0EFF" },
      },
      focus: { inner: "#1A1A1AFF", outer: "#1A1A1AFF" },
    },
    critical: {
      background: { subdued: "#F8C1D9FF", secondary: "#FFFFFFFF" },
      border: { default: "#B61F5EFF" },
      icon: "#B61F5EFF",
    },
    warning: {
      background: { subdued: "#FAE8D6FF", secondary: "#FFFFFFFF" },
      border: { default: "#ED5438FF" },
      icon: "#ED5438FF",
    },
    success: {
      background: { subdued: "#D5EBD3FF", secondary: "#FFFFFFFF" },
      border: { default: "#068343FF" },
      icon: "#068343FF",
    },
    highlight: {
      background: { subdued: "#F2EDFAFF", secondary: "#FFFFFFFF" },
      border: { default: "#513271FF" },
      icon: "#5B3880FF",
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#361A51FF",
          dark: "#513271FF",
          default: "#5B3880FF",
          bright: "#8A59C4FF",
          brightest: "#D5C3EFFF",
          pastel: "#F2EDFAFF",
        },
        secondary: {
          darkest: "#7F4414FF",
          dark: "#C0760EFF",
          default: "#EEB21EFF",
          bright: "#F4CC50FF",
          brightest: "#F8E290FF",
          pastel: "#FBF1C6FF",
        },
        tertiary: {
          darkest: "#3C3D3DFF",
          dark: "#4E4F50FF",
          default: "#6D6F71FF",
          bright: "#AFB0B1FF",
          brightest: "#D0D1D1FF",
          pastel: "#F5F6F6FF",
        },
      },
    },
    primary: {
      background: {
        default: "#513271FF",
        hovered: "#361A51FF",
        pressed: "#513271FF",
        critical: {
          default: "#DD0E0EFF",
          hovered: "#B51414FF",
          pressed: "#DD0E0EFF",
        },
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } },
    },
    secondary: {
      background: {
        default: "#FFFFFFFF",
        hovered: "#DCDCDCFF",
        pressed: "#F0F0F0FF",
      },
      text: { default: "#1A1A1AFF", hovered: "#1A1A1AFF" },
      border: { default: "#1A1A1AFF" },
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#DCDCDCFF",
        pressed: "#F0F0F0FF",
      },
      text: { default: "#1A1A1AFF", hovered: "#1A1A1AFF" },
      border: { default: "#DCDCDCFF" },
    },
    input: {
      border: {
        success: "#507C03FF",
        warning: "#C94F08FF",
        default: "#949494FF",
        hovered: "#4E4E4EFF",
        disabled: "#D6D6D6FF",
        critical: "#DD0E0EFF",
      },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF",
      },
    },
    dataViz: {
      interface: { track: { border: "#959595FF", background: "#D5C3EFFF" } },
      singleColor: { brand: "#5B3880FF", neutral: "#959595FF" },
      status: {
        critical: "#DD0E0EFF",
        warning: "#F16501FF",
        success: "#0DA80AFF",
      },
      categorical: {
        one: "#1A1A1AFF",
        two: "#6212E6FF",
        three: "#F0184CFF",
        four: "#2695E6FF",
        five: "#F16501FF",
        six: "#0DA80AFF",
      },
    },
    tag: {
      neutral: {
        background: { bold: "#3B3B3BFF", subdued: "#E9E9E9FF" },
        border: { bold: "#3B3B3BFF", subdued: "#E9E9E9FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" },
      },
      one: {
        background: { bold: "#5B3880FF", subdued: "#EDEAF5FF" },
        border: { bold: "#5B3880FF", subdued: "#EDEAF5FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" },
      },
      two: {
        background: { bold: "#135D03FF", subdued: "#DEEADCFF" },
        border: { bold: "#135D03FF", subdued: "#DEEADCFF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" },
      },
      three: {
        background: { bold: "#994000FF", subdued: "#F2EEE6FF" },
        border: { bold: "#994000FF", subdued: "#F2EEE6FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" },
      },
      four: {
        background: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        border: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" },
      },
      success: {
        background: { bold: "#008A09FF", subdued: "#E3F7F0FF" },
        border: { bold: "#008A09FF", subdued: "#E3F7F0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#02692BFF" },
      },
      warning: {
        background: { bold: "#B85B0FFF", subdued: "#FAE8D6FF" },
        border: { bold: "#B85B0FFF", subdued: "#FAE8D6FF" },
        text: { bold: "#FFFFFFFF", subdued: "#9F3703FF" },
      },
      critical: {
        background: { bold: "#DD0E0EFF", subdued: "#F9E1E2FF" },
        border: { bold: "#DD0E0EFF", subdued: "#F9E1E2FF" },
        text: { bold: "#FFFFFFFF", subdued: "#BB1111FF" },
      },
      informational: {
        background: { bold: "#2E5CDFFF", subdued: "#E8F8FFFF" },
        border: { bold: "#2E5CDFFF", subdued: "#E8F8FFFF" },
        text: { bold: "#FFFFFFFF", subdued: "#225ECEFF" },
      },
    },
  },
  shadows: {
    card: { x: 0, y: 2, blur: 6, spread: 0, color: "#00000014" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#0000001A" },
  },
  typography: {
    headingOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingThree: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingFour: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 800,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 800,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOneSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwoSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    buttonOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    buttonTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    label: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    overline: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none",
    },
    caption: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    tab: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
    eighth: 2,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6,
    progressBar: 9999,
    tags: 4,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: {
    headings:
      "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  transitions: { defaultTime: "200ms" },
};
